import { render, staticRenderFns } from "./QuestionBlockForm.vue?vue&type=template&id=748ff29d"
import script from "./QuestionBlockForm.vue?vue&type=script&lang=js"
export * from "./QuestionBlockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports